import { IconExternalLink } from "@/assets/icons/geist/IconExternalLink";
import type { PromptValidationWarningWithOriginal } from "@/components/ai/prompt-input/state";
import { Banner } from "@/components/flexkit/Banner";
import { cn } from "@/components/podkit/lib/cn";
import type { FC } from "react";

type PromptValidationWarningBannerProps = {
    warning: PromptValidationWarningWithOriginal;
    onUndo: () => void;
    className?: string;
};

export const PromptValidationWarningBanner: FC<PromptValidationWarningBannerProps> = ({
    warning,
    onUndo,
    className,
}) => {
    return (
        <Banner
            variant="warning"
            data-tracking-id="prompt-validation-warning-banner"
            LeadingIcon={null}
            text={
                <span>
                    <span className="font-bold">
                        {warning.removedCount === 1
                            ? "1 deceptive character was"
                            : `${warning.removedCount} deceptive characters were`}
                    </span>{" "}
                    <span>removed from your message.</span>
                </span>
            }
            link={
                <a
                    href="https://ona.com/docs/ona/guardrails/prompt-validation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex shrink-0 items-center gap-1 text-sm text-content-secondary hover:text-content-primary"
                >
                    Learn more
                    <IconExternalLink size="sm" />
                </a>
            }
            action={{
                text: "Undo",
                onClick: onUndo,
                "data-tracking-id": "prompt-validation-undo",
            }}
            className={cn("shadow-none [&_[data-testid=banner-text]]:flex-1", className)}
        />
    );
};
